export const compareObjectsStr = (a, b, fieldKey = 'label')  => {
    return a[fieldKey] > b[fieldKey] ? 1 : b[fieldKey] > a[fieldKey] ? -1 : 0;
}